import React from "react";
import style from "./index.module.scss";
import ExerciseStaticsOption from "../ExerciseStaticsOption";
import RightWrongCount from "../RigthWrongCount";
import { BaseQuestionType, EndExerciseQuestion } from "service/exercise";
import { isTrue } from "service/service";
import { indexToChar } from "utils/common";
import classNames from "classnames";

interface TopicDetailProps {
    index: number;
    data: EndExerciseQuestion;
    subQuestion?: boolean;
}

export default function TopicDetail({
    index,
    data,
    subQuestion
}: TopicDetailProps) {
    function getRightOptions() {
        if (
            ![
                BaseQuestionType.SingleChoice,
                BaseQuestionType.MultipleChoice,
                BaseQuestionType.Judge
            ].includes(data.queTypeId)
        )
            return;

        return (
            data.optionModelList
                ?.map((item, index) => ({
                    ...item,
                    char:
                        data.queTypeId === BaseQuestionType.Judge
                            ? item.description
                            : indexToChar(index)
                }))
                .filter(item => isTrue(item.isRight))
                .map(item => item.char)
                .join("") || ""
        );
    }

    return (
        <div
            className={classNames({
                [style.root]: !subQuestion,
                [style.subRoot]: subQuestion
            })}>
            <div className={style.info}>
                {subQuestion ? <em>({index + 1}).</em> : <em>{index + 1}.</em>}
                （{data.queTypeName}，{data.score}分）
                {data.queTypeId < BaseQuestionType.Mixed && (
                    <span className={style.rate}>
                        {data.queTypeId === BaseQuestionType.Subjective
                            ? `暂不提供主观题的作答正确率`
                            : `正确率${data.accuracy}`}
                    </span>
                )}
            </div>

            <div
                className={style.trunk}
                dangerouslySetInnerHTML={{ __html: data.contentText }}
            />

            {[
                BaseQuestionType.SingleChoice,
                BaseQuestionType.MultipleChoice
            ].includes(data.queTypeId) && (
                <div className={style.options}>
                    {data.optionModelList?.map((option, index) => (
                        <ExerciseStaticsOption
                            key={option.id}
                            index={index}
                            data={option}
                            queTypeId={data.queTypeId}
                        />
                    ))}
                </div>
            )}

            {[
                BaseQuestionType.SingleChoice,
                BaseQuestionType.MultipleChoice,
                BaseQuestionType.Judge,
                BaseQuestionType.Fill
            ].includes(data.queTypeId) && (
                <RightWrongCount
                    rightList={data.stuRightList || []}
                    wrongList={data.stuUnRightList || []}
                />
            )}

            {[
                BaseQuestionType.SingleChoice,
                BaseQuestionType.MultipleChoice,
                BaseQuestionType.Judge,
                BaseQuestionType.Fill
            ].includes(data.queTypeId) && (
                <div className={style.answer}>
                    <h1>【正确答案】 {getRightOptions()}</h1>

                    {data.queTypeId === BaseQuestionType.Fill &&
                        data.optionModelList.map((option, index) => (
                            <p key={option.id}>
                                填空{index + 1}：{option.description}
                            </p>
                        ))}
                </div>
            )}

            {data.queTypeId === BaseQuestionType.Subjective && (
                <div className={style.answerSuggested}>
                    <h1>
                        参考答案{" "}
                        <span className={style.answerTip}>
                            (活动结束后学生可见)
                        </span>
                    </h1>
                    <div dangerouslySetInnerHTML={{ __html: data.analysis }} />
                </div>
            )}

            {data.questionModelList?.map((question, index) => (
                <TopicDetail
                    key={question.id}
                    index={index}
                    data={question}
                    subQuestion
                />
            ))}
        </div>
    );
}
